import React from 'react';
import ReactDOM from 'react-dom';

import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(1, 1, 1, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    max-width: 600px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    background: white;
    padding-left: 30px;
    padding-right: 30px;
    line-height: 30px;
    text-align: center;
    p {
      font-size: 1.6rem;
    }
    .row {
      display: flex;
      width: 100%;
      justify-content: space-around;
      div {
        font-size: 1.6rem;
        height: 50px;
        width: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: red;
        color: white;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
`;

function Confirmation({ resolve, question, statement }) {
  function clickYes() {
    removeModal();
    resolve({ ok: true });
  }
  function clickNo() {
    removeModal();
    resolve({ ok: false });
  }
  debugger;
  return (
    <Wrapper>
      <div className='modal'>
        <div>
          <p>{statement ? statement : null}</p>
          <p>{question}</p>
        </div>
        <div className='row'>
          <div onClick={clickYes}>Yes</div>
          <div onClick={clickNo}>No</div>
        </div>
      </div>
    </Wrapper>
  );
}

export function getConfirmation(question, statement) {
  return new Promise((resolve, reject) => {
    addModal(resolve, question, statement);
  });
}

function addModal(resolve, question, statement) {
  const body = document.getElementsByTagName('body')[0];
  const div = document.createElement('div');
  div.setAttribute('id', 'Confirmation-container');
  body.appendChild(div);
  ReactDOM.render(
    <Confirmation
      resolve={resolve}
      question={question}
      statement={statement}
    />,
    div
  );
}

function removeModal() {
  const div = document.getElementById('Confirmation-container');
  const body = document.getElementsByTagName('body')[0];
  body.removeChild(div);
}
